module.exports = __webpack_public_path__ + "media/images/lp_chintai/sec01_img_01-46de9068b638e730731c8a0110b50a1b.jpg";